export function SubpageCta({
  title = "Bereit für Ihre unabhängige Analyse?",
  subtitle = "Starten Sie Ihr Projekt – kostenlos, neutral und ohne Vermittlung.",
  primaryLabel = "Projekt starten",
  primaryHref = "/#projekt",
  secondaryLabel = "Angebote vergleichen",
  secondaryHref = "/#projekt",
}: {
  title?: string;
  subtitle?: string;
  primaryLabel?: string;
  primaryHref?: string;
  secondaryLabel?: string;
  secondaryHref?: string;
}) {
  return (
    <section className="surface-deep">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-16 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
        <div className="md:col-span-7">
          <h2 className="font-display text-3xl md:text-5xl leading-tight text-[var(--paper)]">{title}</h2>
          <p className="mt-4 text-[var(--paper)]/75 text-lg max-w-xl">{subtitle}</p>
        </div>
        <div className="md:col-span-5 flex flex-col sm:flex-row md:justify-end gap-3">
          <a
            href={primaryHref}
            className="inline-flex items-center justify-center gap-2 bg-[var(--leaf)] hover:bg-[var(--gold)] text-[var(--paper)] px-6 py-3 rounded-sm transition"
          >
            {primaryLabel} <span aria-hidden>→</span>
          </a>
          <a
            href={secondaryHref}
            className="inline-flex items-center justify-center gap-2 border border-[var(--paper)]/40 text-[var(--paper)] hover:bg-[var(--paper)]/10 px-6 py-3 rounded-sm transition"
          >
            {secondaryLabel}
          </a>
        </div>
      </div>
    </section>
  );
}
